import { render, staticRenderFns } from "./KBItem.vue?vue&type=template&id=f138c0a8&"
import script from "./KBItem.vue?vue&type=script&lang=js&"
export * from "./KBItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports